import { Navigate } from 'react-router-dom';
import { useAuth } from '@/features/auth/hooks/useAuth';
import { hasFullDashboardAccess } from '@/features/auth/roleAccess';
import { MainDashboardPage } from '@/features/budgets/pages/MainDashboardPage';

const SCHOOL_PROFILE_PATH = '/reports/school-profile';

/**
 * Home `/`: full-access users see the main dashboard; school/parent roles land on School Profile only.
 */
export function HomeEntryPage() {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex min-h-[40vh] items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-indigo-600 border-t-transparent" />
      </div>
    );
  }

  if (!hasFullDashboardAccess(user?.roles)) {
    return <Navigate to={SCHOOL_PROFILE_PATH} replace />;
  }

  return <MainDashboardPage />;
}
